import { FormControl, TextField, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "./AutocompleteUserDropdown.styles";
import * as React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";

export interface IAutocompleteUserDropdown extends WithStyles<typeof styles> {
    allUsers: any,
    selectedUserId: any,
    handleUserChange: any
    disabled?: boolean;
}

const AutocompleteUserDropdownPure: React.FunctionComponent<IAutocompleteUserDropdown> = ({
    allUsers, selectedUserId, handleUserChange, disabled, classes
}: IAutocompleteUserDropdown) => {
    return <>
        <FormControl required variant="outlined" className={classes.formControl}>
        <Autocomplete
            classes={{
                inputRoot: classes.aCInputRoot,
                option: classes.aCOption,
                listbox: classes.aCListbox
            }}
                id="userSelect"
                options={allUsers}
                getOptionLabel={(option: any) => option.email}
                value={allUsers.find(user => user.userId === selectedUserId)}
                renderInput={params => <TextField {...params} variant="outlined" />}
                renderOption={(option: any) => (
                    <React.Fragment>
                        {`${option.email} - ${option.firstName} ${option.lastName}`}
                    </React.Fragment>
                )}
                onChange={(event, user) => handleUserChange(user)}
                disabled={disabled}
                getOptionSelected={(option, value) => option.userId === value.userId}
            />
        </FormControl>
    </>
};

export const AutocompleteUserDropdown = withStyles(styles)(AutocompleteUserDropdownPure);